import React, {Component} from "react"
import {connect} from "react-redux"
import {Page} from "../../constants/page/pages"
import {changeActualPage} from "../../shared-components/actions/temporaries/page/pageActions"
import {
    updatePagination,
    goToPage,
    updateMaxPages,
} from "../../shared-components/actions/temporaries/pagination/paginationActions"
import {getTotalResults} from "../../store/selectors/temporaries/paginationSelectors"
import {isFetching} from "../../store/selectors/requests/requestsSelectors"
import {getRefundsOfIntervenant, getBackEndField} from "../../shared-components/actions/entities/refunds/refundsActions"
import {RequestInfo, RequestKeys} from "../../shared-components/constants/requests"
import {keys} from "lodash"
import {RefundTrackSelectValues} from "../../shared-components/constants/refundTracks"
import {RefundChannelSelectValues} from "../../shared-components/constants/refundChannels"
import HistoryRefundScene from "./historyRefund"
import {getUserIntervenantId} from "../../store/selectors/sessionStorage/userSelectors"
import {getIds} from "../../store/selectors/entities/entitiesSelectors"
import {Entity, EntityInfo} from "../../shared-components/constants/entities"
import {fillData} from "../../shared-components/actions/temporaries/table/tableAction"
import {generateHandOverPdf} from "../../shared-components/actions/temporaries/handOverCheckbooks/handOverCheckbooksActions"
import {getFileName} from "../../store/selectors/entities/fileRefundDepositsSelectors"
import {clearRefundDetails, viewRefundDetails} from "../../actions/temporaries/detailsRefund/detailsRefundActions"
import {getDetailsRefundId} from "../../store/selectors/temporaries/detailsRefundSelectors"
import Scroll from "react-scroll"
import withRouter from "../../shared-components/wrappers/withRouter"

class HistoryRefundSceneContainer extends Component {
    constructor() {
        super()

        const nullValueTrack = [
            {
                key: 10,
                value: null,
                text: "Non renseigné",
            },
        ]
        const nullValueChannel = [
            {
                key: 20,
                value: null,
                text: "Non renseigné",
            },
        ]

        const refundTrackSelectValues = nullValueTrack.concat(
            keys(RefundTrackSelectValues).map((key, index) => ({
                key: index,
                value: key,
                text: RefundTrackSelectValues[key],
            })),
        )

        const refundChannelSelectValues = nullValueChannel.concat(
            keys(RefundChannelSelectValues).map((key, index) => ({
                key: index,
                value: key,
                text: RefundChannelSelectValues[key],
            })),
        )

        this.state = {
            isDetailsOpen: false,
            paginationComponent: "historyRefundTablePagination",
            refundChannelSelectValues,
            refundTrackSelectValues,
            sortedDirection: "DESC",
            sortedField: getBackEndField("refundDate"),
            tableName: "historyRefundTable",
        }
    }

    componentDidMount() {
        // Update breadcrumb
        this.props.updateActualPage()
        this.changePage()
    }

    componentWillUnmount() {
        this.closeDetailsRefundBox()
    }

    /**
     * Change table page
     */
    changePage = (pageNumber = 0) => {
        this.props
            .getRefundsOfIntervenant(
                pageNumber,
                this.state.sortedField,
                this.state.sortedDirection,
                10,
                this.state.searchFormValues,
            )
            .then(pagination => {
                // fill the table
                this.props.fillData(this.state.tableName, this.props.refundsIds)

                // Update the pagination component
                this.props.updatePagination(this.state.paginationComponent, pagination)
            })
            .catch(err => console.error(err))
    }

    /**
     * Close the details refund box
     */
    closeDetailsRefundBox = () => {
        this.setState({isDetailsOpen: false})
        this.props.clearRefundDetails()
    }

    /**
     * Method to download the slip refund file by providing the refund id
     * @param id RefundId
     */
    downloadSlipRefundFile = id => {
        this.props.downloadRefundFile(id).catch(err => console.error(err))
    }

    /**
     * When a user sort a column from table
     * @param sortedField
     * @param sortDirection
     */
    sortColumn = (sortedField, sortDirection) => {
        this.setState(
            {
                sortedField: getBackEndField(sortedField),
                sortedDirection: sortDirection === "ascending" ? "ASC" : "DESC",
            },
            () => {
                // Update table
                this.changePage()

                // Go to first page
                this.props.goToPage(this.state.paginationComponent, 1)
            },
        )
    }

    /**
     * Function to load the refunds searched by searchformvalues
     * @param searchFormValues searchformsvalues provided by the RapidSearchForm
     */
    onSubmit = searchFormValues => {
        this.setState({searchFormValues: searchFormValues}, () => {
            this.changePage(0, this.state.searchFormValues)
        })
        this.closeDetailsRefundBox()
    }

    /**
     * Open the details refund box and load data by the id provided and scroll to it
     * @param id Refund Id
     */
    openDetailsRefundBox = id => {
        this.props.viewRefundDetails(id)
        this.setState({isDetailsOpen: true})
        Scroll.scroller.scrollTo("anchor-refund-details", {
            duration: 800,
            delay: 100,
            smooth: "easeInOutQuart",
        })
    }

    render = () => {
        return (
            <HistoryRefundScene
                changePage={this.changePage}
                closeDetailsRefundBox={this.closeDetailsRefundBox}
                detailsRefundId={this.props.detailsRefundId}
                downloadSlipRefundFile={this.downloadSlipRefundFile}
                intervenantId={this.props.intervenantId}
                isDetailsOpen={this.state.isDetailsOpen}
                isFetchingHandoverPdf={this.props.isFetchingHandoverPdf}
                isFetchingRefundRetrieve={this.props.isFetchingRefundRetrieve}
                onSubmit={this.onSubmit}
                openDetailsRefundBox={this.openDetailsRefundBox}
                refundChannelSelectValues={this.state.refundChannelSelectValues}
                refundTrackSelectValues={this.state.refundTrackSelectValues}
                refundsIds={this.props.refundsIds}
                sortColumnFunction={this.sortColumn}
                totalResults={this.props.totalResults(this.state.paginationComponent)}
            />
        )
    }
}

const mapStateToProps = state => ({
    detailsRefundId: getDetailsRefundId(state),
    getFileName: id => getFileName(state, id),
    intervenantId: getUserIntervenantId(state),
    isFetchingHandoverPdf: isFetching(state, RequestInfo[RequestKeys.GENERATE_HANDOVER_PDF].name),
    isFetchingRefundRetrieve: isFetching(state, EntityInfo[Entity.REFUNDS].name),
    refundsIds: getIds(state, EntityInfo[Entity.REFUNDS].name),
    totalResults: componentName => getTotalResults(state, componentName),
})

const mapDispatchToProps = dispatch => ({
    clearRefundDetails: () => dispatch(clearRefundDetails()),
    downloadRefundFile: detailsRefundId => dispatch(generateHandOverPdf(detailsRefundId)),
    fillData: (tableName, refundsIds) => dispatch(fillData(tableName, refundsIds)),
    getRefundsOfIntervenant: (page, sortedField, sortedDirection, limit, searchFormValues) =>
        dispatch(getRefundsOfIntervenant(page, sortedField, sortedDirection, limit, searchFormValues)),
    goToPage: (componentName, page) => dispatch(goToPage(componentName, page)),
    updateActualPage: () => dispatch(changeActualPage(Page.HISTORY_REFUND)),
    updateMaxPages: (componentName, maxPages) => dispatch(updateMaxPages(componentName, maxPages)),
    updatePagination: (componentName, pagination) => dispatch(updatePagination(componentName, pagination)),
    viewRefundDetails: detailsRefundId => dispatch(viewRefundDetails(detailsRefundId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HistoryRefundSceneContainer))
